import React from "react";
import { AlertOctagon } from "lucide-react";

export const PausedBanner = ({ onResume }) => (
  <div
    data-testid="paused-banner"
    className="kz-fade-up flex items-center gap-3 px-4 py-3 rounded-2xl border border-red-500/30 bg-red-500/10 mb-6"
  >
    <AlertOctagon size={18} className="text-red-400 shrink-0" />
    <p className="text-sm text-red-200 flex-1">
      <span className="font-semibold">Everything is paused.</span> All in-flight sends halted, nothing new goes out until you resume.
    </p>
    <button
      data-testid="banner-resume-btn"
      onClick={onResume}
      className="px-3 py-1.5 rounded-full text-xs font-semibold bg-emerald-500 text-[#04140d] hover:bg-emerald-400 transition-all hover:scale-[1.02]"
    >
      Resume KURT
    </button>
  </div>
);
